import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
/**
 * The `.ck-content` styles that our documents are rendered and exported with, the same styles that
 * the `docx.css` and `pdf.css` entry points are built from.
 */
import 'shared/domains/pleditor@next/content-styles.css';
export const Container = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 100%;
  padding: ${themeGet('spacing.xl')};
  background-color: ${themeGet('colors.background.50')};
`;
export const DocumentHtml = styled.div `
  /* Keep wide content, e.g. tables and images, inside the sidebar */
  max-width: 100%;

  table {
    max-width: 100%;
  }
`;
export const StateContainer = styled.div `
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: ${themeGet('spacing.xl')};
`;
export const PdfContainer = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  padding: ${themeGet('spacing.md')};
`;
